export default __webpack_public_path__ + "static/media/room-mel-2.f004e930.webp";